/* istanbul ignore file */
export const hasRequireJS = function ($window) {
  if (typeof $window.require == 'undefined') return false
  if (typeof $window.require.s == 'undefined') return false
  if (typeof $window.require.s.contexts == 'undefined') return false
  if (typeof $window.require.s.contexts._ == 'undefined') return false
  if (typeof $window.require.s.contexts._.config != 'object') return false
  return true
}
